module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/th/5-90b777d9a729a94b5ef8c609bc863038.jpg";